import { Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { Archive } from "Services/NGSResultData";
import useLang from "Shared/hooks/useLanguage";

function ArchiveModal({
  show,
  setShow,
  selectedRecord,
  loadGridData,
  setSelectedBox,
}: {
  setShow: any;
  show: boolean;
  selectedRecord: number[];
  loadGridData: (loader: boolean, reset: boolean, sortingState?: any) => void;
  setSelectedBox: any;
}) {
  const { t } = useLang();

  const ModalhandleClose = () => setShow(false);

  const archiveMutation = useMutation({
    mutationFn: async (ids: number[]) => {
      const res = await Archive(ids);
      return res;
    },

    onSuccess: (res) => {
      if (res?.data?.statusCode === 200) {
        setSelectedBox({ ids: [] });
        loadGridData(true, true);
        ModalhandleClose();
        toast.success(t(res?.data?.message));
      } else {
        toast.error(t(res?.data?.message));
      }
    },

    onError: (error: any) => {
      console.error(error, "bulk request failure");
    },
  });

  return (
    <Modal
      show={show}
      onHide={ModalhandleClose}
      backdrop="static"
      keyboard={false}
      className="d-flex align-item-center"
      dialogClassName="no-shadow-modal-content"
    >
      <Modal.Header closeButton className="py-4 bg-light-primary">
        <Modal.Title className="h5">{t("Archive Record")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t("Are you sure you want to archive this record?")}
      </Modal.Body>
      <Modal.Footer className="py-2">
        <button
          id="NGSResultDataModalArchiveCancel"
          type="button"
          className="btn btn-sm btn-secondary"
          onClick={ModalhandleClose}
        >
          {t("Cancel")}
        </button>
        <button
          id="NGSResultDataModalArchiveSave"
          type="button"
          className="btn btn-sm btn-danger"
          onClick={() => archiveMutation.mutate(selectedRecord)}
        >
          {t("Archive")}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ArchiveModal;
